import GenericPatientDetailsList from "../components/GenericPatientDetailsList";

const MedicalOpinionPatientsList = () => {
  return (
    <GenericPatientDetailsList
      header="Medical Opinion"
      screen="medical_opinion"
      iconUrl="/medical_opinion"
    />
  );
};

export default MedicalOpinionPatientsList;
